import { OWL_ESULTS_PROFILE_ANCHOR_BGR_KEY, OWL_ESULTS_PROFILE_ANCHOR_RECT, OWL_ESULTS_PROFILE_ANCHOR_RGB_KEY, OWL_TOTA_PROFILE_ANCHOR_BGR_KEY, OWL_TOTA_PROFILE_ANCHOR_RECT, OWL_TOTA_PROFILE_ANCHOR_RGB_KEY, } from './generated/owl-prefix-metrics.js';
import { getRgb, relativeTo } from './image.js';
/** Encode exact-black pixels as one 12-bit column mask per UTF-16 code unit. */
function anchorKeyAt(source, rect) {
    let key = '';
    for (let x = 0; x < rect.width; x++) {
        let mask = 0;
        for (let y = 0; y < rect.height; y++) {
            const [r, g, b] = getRgb(source, rect.x + x, rect.y + y);
            if (r === 0 && g === 0 && b === 0)
                mask |= 1 << y;
        }
        key += String.fromCharCode(mask);
    }
    return key;
}
function matchVariant(key, rgbKey, bgrKey) {
    if (key === rgbKey)
        return 'cleartype-rgb';
    if (key === bgrKey)
        return 'cleartype-bgr';
    return null;
}
/** Detect the regular Owl font profile from exact known-prefix anchor pixels. */
export function detectOwlClearTypeVariant(source, layout) {
    const esultsKey = anchorKeyAt(source, relativeTo(layout.window.rect, OWL_ESULTS_PROFILE_ANCHOR_RECT));
    const esultsVariant = matchVariant(esultsKey, OWL_ESULTS_PROFILE_ANCHOR_RGB_KEY, OWL_ESULTS_PROFILE_ANCHOR_BGR_KEY);
    if (esultsVariant)
        return esultsVariant;
    const totaKey = anchorKeyAt(source, relativeTo(layout.window.rect, OWL_TOTA_PROFILE_ANCHOR_RECT));
    return matchVariant(totaKey, OWL_TOTA_PROFILE_ANCHOR_RGB_KEY, OWL_TOTA_PROFILE_ANCHOR_BGR_KEY);
}
//# sourceMappingURL=profile.js.map